import { CoreFieldInfoLang, CoreInfoLang } from '@aipb/gulliver/castor/model';
import { Language } from '@aipb/shared/util/translation';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { CastorService } from '../../api';
import { FieldRepository } from './field.repository';

const filter = (field: CoreFieldInfoLang, lang: string): boolean =>
  field.dataLang === lang || field.dataLang === 'uni' || field.dataLang === '';
const sort = (a: CoreFieldInfoLang, b: CoreFieldInfoLang): number => a.fieldName.localeCompare(b.fieldName);

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  private _onSetup = new Subject<void>();
  public onSetup$ = this._onSetup.asObservable();

  constructor(
    private castor: CastorService,
    private transloco: TranslocoService,
    private repository: FieldRepository
  ) {}

  setup(coreInfoLang: CoreInfoLang, sortRegisterFields = true): void {
    const lang = Language.getLanguageByIso_639_1(this.transloco.getActiveLang()).iso_639_2;

    const fields = coreInfoLang.coreFields;
    const visibleFields = fields.filter((f) => f.visible && filter(f, lang)).sort((a, b) => sort(a, b));
    const searchFields = fields.filter((f) => f.search && filter(f, lang)); /*.sort((a, b) => this.sort(a, b))*/
    const sortFields = fields.filter((f) => f.sort && filter(f, lang)).sort((a, b) => sort(a, b));
    let registerFields = fields.filter((f) => f.register && filter(f, lang));

    if (sortRegisterFields) {
      registerFields = registerFields.sort((a, b) => sort(a, b));
    }

    this.repository.setFields(coreInfoLang.coreId, {
      search: searchFields,
      visible: visibleFields,
      sort: sortFields,
      register: registerFields
    });

    this._onSetup.next();
  }
}
